export enum QuantityStatus {
  neutral = 'neutral',
  active = 'success',
}

export interface QuantityCardProps {
  className?: string;
  description: string;
  quantity: number | string;
  status?: QuantityStatus;
  testId?: string;
}
